import { Component, ReactNode } from 'react'

interface Props {
  children: ReactNode
  /** При смене значения ошибка сбрасывается — уход со сломанной страницы восстанавливает приложение. */
  resetKey?: string
}

interface State {
  hasError: boolean
}

/**
 * Ловит ошибки рендера в поддереве и показывает дружелюбный экран вместо
 * белого/пустого приложения. Технические детали — только в консоль (для
 * отладки через remote-инспектор), пользователю их не показываем.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: unknown, info: unknown) {
    console.error('ErrorBoundary caught:', error, info)
  }

  componentDidUpdate(prev: Props) {
    if (this.state.hasError && prev.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false })
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div
        style={{
          minHeight: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          padding: 24,
          background: 'var(--color-bg-0)',
          color: 'var(--color-text-0)',
          fontFamily: "'Geist', -apple-system, BlinkMacSystemFont, sans-serif",
        }}
      >
        <h1 style={{ fontSize: 19, fontWeight: 600, margin: '0 0 12px' }}>Что-то сломалось</h1>
        <p style={{ fontSize: 14, opacity: 0.6, maxWidth: 300, margin: '0 0 20px', lineHeight: 1.5 }}>
          Экран не удалось показать. Попробуй ещё раз — если не поможет, напиши в поддержку.
        </p>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
          <button
            onClick={() => window.location.reload()}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 44,
              padding: '0 24px',
              background: 'var(--color-accent-gradient)',
              color: '#fff',
              border: 'none',
              borderRadius: 12,
              fontSize: 15,
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            Перезагрузить
          </button>
          <a
            href="https://t.me/zakharovsemyon"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 44,
              padding: '0 24px',
              background: 'var(--color-bg-2)',
              color: 'var(--color-text-0)',
              border: '1px solid var(--color-border-2)',
              borderRadius: 12,
              fontSize: 15,
              fontWeight: 500,
              textDecoration: 'none',
            }}
          >
            В поддержку
          </a>
        </div>
      </div>
    )
  }
}
